import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ISampleSource } from "../interfaces/sample-source";

@Injectable({
  providedIn: 'root'
})
export class SampleSourceService {
    private rootUrl: string = "/api/sample-sources";

    constructor(private httpClient: HttpClient) { }

    public getSampleSources(): Observable<ISampleSource[]> {
        const url = this.rootUrl;
        return this.httpClient.get<ISampleSource[]>(url);
    }
}
